import { render, staticRenderFns } from "./LeafMenuItem.vue.js?vue&type=template&id=775707eb!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./LeafMenuItem.vue?vue&type=template&id=775707eb"
import script from "./LeafMenuItem.vue.ts?vue&type=script&lang=ts!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./LeafMenuItem.vue?vue&type=script&lang=ts"
export * from "./LeafMenuItem.vue.ts?vue&type=script&lang=ts!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./LeafMenuItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports